import { HttpMethod } from '@teqplay/api'

import { requestBuilder } from '../builder'

export type ISODateTimeString = string

// Shared note type
export type TVesselNote = {
  id: string
  text: string
  email: string
  timestamp: ISODateTimeString
}

// Envelope returned by GET/POST
export type TVesselNotesOutput = {
  arrivalPortId: string
  unlocode: string
  imo: string
  departingVisitId: string
  notes: TVesselNote[]
}

export type TGetVesselNotesInput = {
  arrivalPortId: string
  imo: string
}

const get = requestBuilder
  .type<TGetVesselNotesInput, TVesselNotesOutput>()
  .request(({ input: { arrivalPortId, imo } }) => {
    const params = new URLSearchParams({ arrivalPortId, imo })
    return {
      path: `/v1/notes?${params.toString()}`,
      method: HttpMethod.GET
    }
  })

// POST /v1/notes
// Body: { arrivalPortId, unlocode, imo, note }
// Either arrivalPortId or unlocode is required
export type TPostVesselNoteInput = {
  arrivalPortId?: string
  unlocode?: string
  imo: string
  note: string
}
export type TPostVesselNoteOutput = TVesselNotesOutput

const post = requestBuilder
  .type<TPostVesselNoteInput, TPostVesselNoteOutput>()
  .request(({ input }) => ({
    path: `/v1/notes`,
    method: HttpMethod.POST,
    init: {
      body: JSON.stringify(input)
    }
  }))

export type TDeleteVesselNoteInput = {
  id: string
}
export type TDeleteVesselNoteOutput = TVesselNotesOutput

const del = requestBuilder
  .type<TDeleteVesselNoteInput, TDeleteVesselNoteOutput>()
  .request(({ input: { id } }) => ({
    path: `/v1/notes/${id}`,
    method: HttpMethod.DELETE
  }))

const vesselNotes = { get, post, delete: del }
export default vesselNotes
